










































import {
	computed,
	defineComponent,
	ref,
	Ref,
	watch,
} from '@vue/composition-api';
import { useStepper } from '@front-app/components/stepper/useStepper';
import { EditableSection } from '@front-app/components/userProfile/editableProfileSections';
import { FocusableElement } from '@front-app/hooks/useAsyncModal';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { requestRoleVerification } from '@front-app/services/UserApi/UserApi';
import { roleVerificationRequestStateStore } from '@front-app/store/singletons/UserVerificationRequest';
import SlidingPanel from '@front-app/components/modals/SlidingPanel.vue';
import TrStepper from '@front-app/components/stepper/TrStepper.vue';
import EditorPanels from '@front-app/components/userProfile/editing/EditorPanels.vue';
import SelectRoleStep from './RoleVerificationStepSelectRole.vue';
import ConfirmInfoStep from './RoleVerificationStepConfirmInfo.vue';
import CompletedStep from './RoleVerificationStepCompleted.vue';

const components = [
	ConfirmInfoStep,
	CompletedStep,
];
const componentsWithRoleStep = [
	SelectRoleStep,
	...components,
];

export default defineComponent({
	components: {
		SlidingPanel,
		TrStepper,
		EditorPanels,
	},
	props: {
		backToLabel: {
			type: String,
			required: true,
		},
		isOpen: Boolean,
		hasSelectRoleStep: Boolean,
	},
	setup(props) {
		const currentComponents = computed(() => (props.hasSelectRoleStep ? componentsWithRoleStep : components));
		const numSteps = computed(() => currentComponents.value.length);
		const { currentUser } = CurrentUserStore;

		// Stepper component
		const {
			currentStep,
			animationType,
			nextStep,
			previousStep,
			goToStep,
		} = useStepper({ numSteps: numSteps.value });
		const currentStepComponent = computed(() => currentComponents.value[currentStep.value]);

		watch(() => props.isOpen, (curr) => {
			if (!curr) {
				goToStep(0);
			}
		}, { immediate: true });

		const { track, status } = useAsyncStatus();
		const requestRoleVerificationAndSaveState = async () => {
			await requestRoleVerification();
			roleVerificationRequestStateStore.update();
		};
		const handleSubmit = () => {
			track(requestRoleVerificationAndSaveState());
			nextStep();
		};
		// END Stepper component

		// Profile editing
		const currentEditSection: Ref<EditableSection> = ref(EditableSection.NONE);
		const currentEditExperienceId: Ref<undefined | number> = ref(undefined);
		const returnTo: Ref<null | FocusableElement> = ref(null);

		const openEditModal = async (targetSection: EditableSection, newReturnTo: FocusableElement) => {
			currentEditExperienceId.value = undefined;
			returnTo.value = newReturnTo;
			currentEditSection.value = targetSection;
		};
		const openEditExperienceModal = async (experienceId: number, newReturnTo: FocusableElement) => {
			currentEditExperienceId.value = experienceId;
			returnTo.value = newReturnTo;
			currentEditSection.value = EditableSection.PROFESSIONAL_EXPERIENCE;
		};
		// END Profile editing

		return {
			// Stepper
			status,
			numSteps,
			animationType,
			currentStep,
			currentStepComponent,
			nextStep,
			previousStep,
			handleSubmit,
			// Profile editing
			currentUser,
			EditableSection,
			returnTo,
			currentEditSection,
			currentEditExperienceId,
			openEditModal,
			openEditExperienceModal,
		};
	},
});
